import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { ICustomNotification, ICustomNotificationModal } from '../types/custom-notification.types';

interface CustomNotificationState extends BaseDataReducerInitialState<ICustomNotification> {
  perPage: number;
  currentModal: ICustomNotificationModal | null;
  selectedNotification: ICustomNotification | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<ICustomNotification, CustomNotificationState>(
  'custom-notifications',
);

const customNotificationState: CustomNotificationState = {
  ...initialState,
  perPage: 25,
  currentModal: null,
  selectedNotification: null,
};

export const customNotification = createSlice({
  name: 'customNotification',
  initialState: customNotificationState,
  reducers: {
    setCustomNotificationModal(state, action: PayloadAction<ICustomNotificationModal | null>) {
      state.currentModal = action.payload;
    },
    setSelectedNotification(state, action: PayloadAction<ICustomNotification | null>) {
      state.selectedNotification = action.payload;
    },
    clearCustomNotificationState() {
      return customNotificationState;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as CustomNotificationState, action);
    });
  },
});
export const CustomNotificationAC = AC;
export const setCustomNotificationCurrentPage = AC.setCurrentPage;
export const onCustomNotificationFilter = thunks.onFilter;

export const { setCustomNotificationModal, clearCustomNotificationState, setSelectedNotification } =
  customNotification.actions;
